import React, { useState } from 'react';
import HeaderSection from '../buyCredits/HeaderSection';
import PricingCard from '../buyCredits/PricingCard';
import PaymentModal from '../buyCredits/PaymentModal';
import { useToast } from '@/hooks/use-toast';

const BuyCredits = () => {
    const [selectedPackage, setSelectedPackage] = useState(null);
    const { toast } = useToast();

    const creditPackages = [
        {
            name: "Starter",
            credits: 1000,
            price: 9.99,
            discounted: false,
            discountedPrice: 7.99,
            features: [],
            popular: false
        },
        {
            name: "Plus",
            credits: 10000,
            price: 49.99,
            discounted: false,
            discountedPrice: 39.99,
            features: [],
            popular: false
        },
        {
            name: "Professional",
            credits: 20000,
            price: 99.99,
            discounted: true,
            discountedPrice: 79.99,
            features: [],
            popular: true
        },
        {
            name: "Business",
            credits: 50000,
            price: 199.99,
            discounted: false,
            discountedPrice: 179.99,
            features: [],
            popular: false
        },
        {
            name: "Enterprise",
            credits: 100000,
            price: 349.99,
            discounted: false,
            discountedPrice: 299.99,
            features: [],
            popular: false
        },
        {
            name: "Enterprise Plus",
            credits: 150000,
            price: 499.99,
            discounted: false,
            discountedPrice: 399.99,
            features: [],
            popular: false
        }
    ];

    const handlePurchase = (packageData) => {
        setSelectedPackage(packageData);
    };

    const handleCloseModal = () => {
        setSelectedPackage(null);
    };

    const handlePaymentSuccess = () => {
        toast({
            title: "Purchase Successful!",
            description: `${selectedPackage.credits.toLocaleString()} credits have been added to your account.`,
            duration: 5000,
        });
        handleCloseModal();
    };

    return (
        <div className="container mx-auto py-8 px-4">
            <HeaderSection />

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mx-auto">
                {creditPackages.map((pkg) => (
                    <PricingCard
                        key={pkg.name}
                        packageData={pkg}
                        onPurchase={handlePurchase}
                    />
                ))}
            </div>

            <PaymentModal
                isOpen={!!selectedPackage}
                onClose={handleCloseModal}
                packageData={selectedPackage}
                onSuccess={handlePaymentSuccess}
            />
        </div>
    );
};

export default BuyCredits;